import React, { useEffect, useMemo, useState } from "react";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import he from "he";
import { useDispatch, useSelector } from "react-redux";
import {
  everyReminderTypeUnit,
  genDefAnswerOptions,
  getExpectedStringTime,
  perParticipantOptions,
  PROJECT_PANEL,
  reminderType,
  RESET_SELECTED_SURVEY_CATEGORY,
  SET_SELECTED_SURVEY_CATEGORY,
  SET_STUDY_ID,
  subNumCounting,
  subNumCountingCapital,
  toMinuteValue,
} from "../../../../utils/constants";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  deleteSkipLogicTq,
  deleteXmotTaskQuestion,
  deleteXmotTaskQuestionBlock,
  getCategoriesForXMOT,
  getTriggerDetailsDataById,
  saveXMOTSurvey,
} from "../../../../services/xmotSurvey/survey";
import { TabPanel, TabView } from "primereact/tabview";
import XmotInfoStep from "./CreateSurveyComponents/xmotInfoStep/XmotInfoStep";
import TimelineAndReminder from "./CreateSurveyComponents/TimelineAndReminder";
import Participants from "./CreateSurveyComponents/Participants";
import InstructionsAndTaskQuestion from "./CreateSurveyComponents/InstructionsAndTaskQuestion";
import Credits from "./CreateSurveyComponents/Credits";
import { useGlobalContext } from "../../../../context/GlobalContext";
import { showToast } from "../../../../services/toast/toastService";
import handleError from "../../../../utils/handleError";
import {
  getClientIdFromUrl,
  getRandomizeBlockItems,
  isEmptyCheck,
} from "../../../../utils/commonLogics";

const durationUnitOptions = [
  { name: "Hours", code: 1 },
  { name: "Weeks", code: 2 },
  { name: "Months", code: 3 },
];

const productAlreadyUsedErrMsg =
  "Selected product is already used in another XMOT. Please select another product.";

const CreateSurveyN = () => {
  const { token, user } = useSelector((state) => state.auth);
  const selectedSurveyCategory = useSelector(
    (state) => state.selectedSurveyCategory,
  );
  const {
    studyId,
    categoryName,
    categoryId,
    categoryType,
    mappedCategory,
    isEditMode,
    customRecruits,
    triggerId: storeTriggerId,
    sessionId: storeSessionId,
    isLocked,
  } = selectedSurveyCategory;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const pidFromUrl = searchParams.get("pid");
  const finalStudyId = studyId || pidFromUrl;
  const triggerType = searchParams.get("trigger_type");
  const [loading, setLoading] = useState(false);
  const [deleteTQLoading, setDeleteTQLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [categoryData, setCategoryData] = useState([]);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [maxCompletedStep, setMaxCompletedStep] = useState(null);
  const [isThersholdErr, setIsThersholdErr] = useState(false);
  const [isXmotDraft, setIsXmotDraft] = useState(true);
  const [reminderTextValue, setReminderTextValue] = useState(
    "Reminder - Did someone use [Product Name] around [USAGE-TIME]?",
  );
  const hostname = window.location.hostname;
  // const [isLocked, setIsLocked] = useState(false);
  const { deviceCode, category, product_id, project_id, isDemoCategory } =
    useGlobalContext();
  const [selectePanelProject, setSelectedPanelProject] = useState(
    PROJECT_PANEL.SMART_PANEL,
  );
  const [xmotFormData, setXmotFormData] = useState({
    triggerId: null,
    sessionId: null,
    selectedCategory: "",
    seletedCustomRecruit: "",
    surveyName: "",
    surveyType: "",
    xmotItem: "",
    selectedDropdownValue: "",
    cameraTypeOption: 0,
    photoTypeOption: "photo_audio_recorded",
    trigger_usage_default_x: "",
    trigger_usage_default_y: "",
    trigger_usage_default_z: "",
    trigger_session_seconds: "",
    send_motion: "",
    send_motion_seconds: "",
    send_motion_unit: "",
    reminder: {
      reminderSwitch: true,
      sendReminderToggler: false,
      reminderTypeUnitValue: everyReminderTypeUnit[0].code,
      reminderTypeValue: reminderType[0].code,
      reminderTime: 1,
      reminderText: reminderTextValue,
    },
    timeline: {
      timelineSelection: null,
      windowLength: null,
      expireDuration: 4,
      durationUnit: durationUnitOptions[0].code,
      nextTimeProductUsed: "",
      noOfUsageEvent: null,
      noOfTimeProductUsed: 1,
      typeOfProductUsed: 1,
      triggerXmotOnetimeType: "",
      triggerTimelineType: null,
      triggerTimelineValue: null,
      productUsedWithCondition: {
        selectedDayConditionValue: [],
        selectedWeekConditionValue: [],
      },
      stopXmotBasedOn: null,
      stopXmotValue: "",
      xmotLimitType: perParticipantOptions[0]?.code,
    },
    participants: {
      selectedSegment: "",
      selectedGender: "",
      selectedAgeRange: "",
      selectedBrand: [],
      participantsValues: [],
    },
    instructions: "",
    taskQuestion: "",
    expectedDuration: "",
    expectedSessionDuration: "",
    sessionDurationTime: null,
    thresholdMagnitudeValue: null,
  });
  const [selectedCategory, setSelectedCategory] = useState("");
  const [taskQuestionItems, setTaskQuestionItems] = useState([]);
  const [stopXmotCreditValue, setStopXmotCreditValue] = useState(null);

  const [xmotInfoErrors, setXmotInfoErrors] = useState({});

  const [participantsErrors, setParticipantsErrors] = useState({});

  const [timelineAndReminderErrors, setTimelineAndReminderErrors] = useState(
    {},
  );

  const [instructionAndTQErrors, setInstructionAndTQErrors] = useState({});
  const [isLogicSettingsError, setIsLogicSettingsError] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();

  const lastSegment = location.pathname.split("/").pop();
  const id = lastSegment.split("-").pop();

  const getRandomizeBlocks = useMemo(() => {
    return getRandomizeBlockItems(taskQuestionItems);
  }, [taskQuestionItems]);

  const handleXmotFormChange = (inputField, inputValue) => {
    setXmotFormData((prev) => ({
      ...prev,
      [inputField]: inputValue,
    }));
  };

  const updateThresholdValuesInForm = (thresholdData) => {
    setXmotFormData((prev) => ({
      ...prev,
      ...thresholdData,
    }));
  };

  const getSessionTypeDetailValue = (surveyType) => {
    const { photoTypeOption } = xmotFormData;
    if (surveyType === "text") {
      return "qualsights_survey";
    } else if (surveyType === "audio") {
      return "onscreen_task_recorded";
    } else if (surveyType === "video") {
      return null;
    } else {
      return photoTypeOption;
    }
  };

  const getXmotInfoPaylods = () => {
    const {
      surveyName,
      xmotItem,
      selectedDropdownValue,
      seletedCustomRecruit,
      thresholdMagnitudeValue,
      surveyType,
      cameraTypeOption,
      triggerId,
      sessionId,
      trigger_usage_default_x,
      trigger_usage_default_y,
      trigger_usage_default_z,
      trigger_session_seconds,
      send_motion,
      send_motion_seconds,
      send_motion_unit,
    } = xmotFormData;
    return {
      category_type: triggerType,
      trigger_id: triggerId,
      session_id: sessionId,
      client_id: parseInt(getClientIdFromUrl(hostname)),
      project_id: parseInt(finalStudyId),
      trigger_name: surveyName,
      session_type: "recorded",
      orientation: surveyType === "text" ? 1 : 0,
      trigger_product_type: xmotItem,
      study_id: finalStudyId,
      tag_products_id: selectedDropdownValue,
      trigger_status: 0,
      trigger_usage_xyz_threshold_magnitude: thresholdMagnitudeValue,
      session_category: surveyType,
      session_type_details: "recorded",
      session_type_value_details: getSessionTypeDetailValue(surveyType),
      camera_value:
        surveyType === "video" && surveyType === "photo" ? cameraTypeOption : 0,
      is_trigger_session: triggerType === "tag" ? 1 : 0,
      is_coaster_trigger_session: triggerType === "coaster" ? 1 : 0,
      session_status_for_app: "1",
      xmot_client_id:
        user?.type === "superadmin" ? parseInt(id) : parseInt(user?.id),
      xmot_draft: isXmotDraft ? 1 : 0,
      xmot_recruit_id: seletedCustomRecruit?.recruit_id,
      xmot_steps:
        (maxCompletedStep && maxCompletedStep) > 1 ? maxCompletedStep : 1,
      trigger_usage_default_x: trigger_usage_default_x || 0,
      trigger_usage_default_y: trigger_usage_default_y || -1,
      trigger_usage_default_z: trigger_usage_default_z || 0,
      trigger_session_seconds: trigger_session_seconds,
      send_motion: parseInt(send_motion),
      send_motion_seconds: send_motion_seconds,
      send_motion_unit: send_motion_unit,
    };
  };

  const getTimelineReminderPaylods = () => {
    const { xmotItem, timeline, triggerId, sessionId, reminder } = xmotFormData;

    return {
      category_type: triggerType,
      trigger_id: triggerId,
      session_id: sessionId,
      trigger_push_notification_text: getTriggerPushNotificationText(xmotItem),
      trigger_timeline_type: timeline?.triggerTimelineType || null,
      trigger_timeline_value: timeline?.triggerTimelineValue || null,
      trigger_reminder_type: parseInt(reminder?.reminderTypeValue),
      trigger_reminder_value_in_hours: reminder?.reminderTime,
      reminder_text: reminder?.reminderText,
      trigger_window_length: parseInt(timeline.windowLength),
      reminder_on_off: reminder?.reminderSwitch ? 1 : 0,
      trigger_session_expire_value: timeline?.expireDuration,
      trigger_session_expire_unit: parseInt(timeline?.durationUnit),
      trigger_reminder_unit: parseInt(reminder?.reminderTypeUnitValue),
      trigger_xmot_type: parseInt(timeline.timelineSelection),
      trigger_xmot_onetime_type: parseInt(timeline?.trigger_xmot_onetime_type),
      trigger_xmot_onetime_time: getTimeDayPipeValues(
        timeline?.productUsedWithCondition?.selectedDayConditionValue,
      ),
      trigger_xmot_onetime_day: getTimeDayPipeValues(
        timeline?.productUsedWithCondition?.selectedWeekConditionValue,
      ),
      xmot_stop_on: timeline?.stopXmotBasedOn,
      xmot_stop_credit_limit:
        timeline?.stopXmotBasedOn === 1 ? timeline?.stopXmotValue : null,
      xmot_stop_part_limit:
        timeline?.stopXmotBasedOn === 2 ? timeline?.stopXmotValue : null,
      xmot_stop_date:
        timeline?.stopXmotBasedOn === 3 ? timeline?.stopXmotValue : null,
      xmot_steps:
        (maxCompletedStep && maxCompletedStep) > 2 ? maxCompletedStep : 2,
      xmot_limit_type: parseInt(timeline?.xmotLimitType),
    };
  };

  const getParticipantsPaylods = () => {
    const { participants, triggerId, sessionId } = xmotFormData;
    return {
      category_type: triggerType,
      trigger_id: triggerId,
      session_id: sessionId,
      project_id: parseInt(finalStudyId),
      participant_type: participants?.participantsValues?.length
        ? participants?.participantsValues?.map((item) => item).join(",")
        : "",
      xmot_gender: participants?.selectedGender,
      xmot_age_range: participants?.selectedAgeRange?.length
        ? participants?.selectedAgeRange?.map((item) => item).join(",")
        : "",
      xmot_brand: participants?.selectedBrand?.length
        ? participants?.selectedBrand?.map((item) => item).join(",")
        : "",
      assign_to_participant: participants?.participantsValues?.length
        ? participants?.participantsValues?.map((item) => item).join(",")
        : "",
      xmot_segment: participants?.selectedSegment?.length
        ? participants?.selectedSegment?.map((item) => item).join(",")
        : "",
      xmot_steps:
        (maxCompletedStep && maxCompletedStep) > 3 ? maxCompletedStep : 3,
    };
  };

  const getTQPaylods = () => {
    const {
      instructions,
      sessionDurationTime,
      sessionId,
      triggerId,
      expectedSessionDuration,
      seletedCustomRecruit,
      timeline,
      surveyType,
    } = xmotFormData;
    const { recruit_value: totalParticipants } = seletedCustomRecruit;
    const { stopXmotBasedOn, stopXmotValue } = timeline;
    const expectedDur = toMinuteValue(expectedSessionDuration);
    const estimatedUsedCredits =
      stopXmotBasedOn === 1
        ? stopXmotValue
        : stopXmotBasedOn === 2
          ? stopXmotValue * expectedDur * totalParticipants
          : expectedDur * totalParticipants;

    return {
      category_type: triggerType,
      trigger_id: triggerId,
      session_id: sessionId,
      project_id: parseInt(finalStudyId),
      session_instruction: instructions,
      session_duration: sessionDurationTime,
      tasks: getTaskQuestions(surveyType),
      session_skip_logic: getSkipLogicPayloadData(),
      estimated_credits: estimatedUsedCredits,
      xmot_steps:
        (maxCompletedStep && maxCompletedStep) > 4 ? maxCompletedStep : 4,
    };
  };

  const handleSaveContinue = (index) => {
    if (index === 0) {
      if (!validateXmotInfo()) {
        return false;
      }
      handleStepSave(getXmotInfoPaylods(), "save-info");
    }
    if (index === 1) {
      if (!validateTimelineAndReminder()) {
        return false;
      }
      handleStepSave(getTimelineReminderPaylods(), "save-timeline");
    }
    if (index === 2) {
      // if (!validateParticipants()) {
      //   return false;
      // }
      // if(xmotFormData?.participants?.participantsValues?.length === 0) {
      //   showToast({
      //     severity: "error",
      //     summary: "Error",
      //     detail: "Please select at least one participant.",
      //     life: 4000
      //   });
      //   return false;
      // }
      handleStepSave(getParticipantsPaylods(), "save-participant");
    }
    if (index === 3) {
      if (!validateInstructionAndTQ() || validateTaskQuestion()) {
        return false;
      }
      handleStepSave(getTQPaylods(), "save-task-question");
    }
  };

  const handleSaveLastStep = (saveType, index) => {
    if (saveType === "draft") {
      navigate(
        `/admin-panel/survey/fromClient-${user?.type === "superadmin" ? parseInt(id) : parseInt(user?.id)}`,
      );
    } else {
      const {
        sessionId,
        triggerId,
        seletedCustomRecruit,
        expectedSessionDuration,
        timeline,
      } = xmotFormData;
      const { recruit_value: totalParticipants } = seletedCustomRecruit;
      const { stopXmotBasedOn, stopXmotValue } = timeline;
      const expectedDur = toMinuteValue(expectedSessionDuration);
      const estimatedUsedCredits =
        stopXmotBasedOn === 1
          ? stopXmotValue
          : stopXmotBasedOn === 2
            ? stopXmotValue * expectedDur * totalParticipants
            : expectedDur * totalParticipants;
      handleSaveContinue(index, "publish");
      if (xmotFormData?.participants?.participantsValues?.length === 0) {
        showToast({
          severity: "error",
          summary: "Error",
          detail: "Please select at least one participant.",
          life: 4000,
        });
        return false;
      }
      let creditsPayload = {
        category_type: triggerType,
        trigger_id: triggerId,
        session_id: sessionId,
        xmot_draft: 0,
        xmot_steps: 5,
        estimated_credits: estimatedUsedCredits,
      };
      handleStepSave(creditsPayload, "save-credit", "publish");
    }
  };

  const getTriggerPushNotificationText = (trigger_product_type) => {
    if (trigger_product_type === "product") {
      return categoryType === "tag"
        ? "Did someone use [Product Name] around [USAGE-TIME]?"
        : "Did someone use [Product Name] around [USAGE-TIME]?";
    }

    if (trigger_product_type === "device") {
      return categoryType === "tag"
        ? "Did someone use [Device Name] around [USAGE-TIME]?"
        : "Did someone use [Device Name] around [USAGE-TIME]?";
    }

    if (trigger_product_type === "appliance") {
      return categoryType === "tag"
        ? "Did someone use [Appliance Name] around [USAGE-TIME]?"
        : "Did someone use [Appliance Name] around [USAGE-TIME]?";
    }
  };

  useEffect(() => {
    if (xmotFormData?.xmotItem === "product") {
      setReminderTextValue(
        "Reminder - Did someone use [Product Name] around [USAGE-TIME]?",
      );
    }

    if (xmotFormData?.xmotItem === "device") {
      setReminderTextValue(
        "Reminder - Did someone use [Device Name] around [USAGE-TIME]?",
      );
    }

    if (xmotFormData?.xmotItem === "appliance") {
      setReminderTextValue(
        "Reminder - Did someone use [Appliance Name] around [USAGE-TIME]?",
      );
    }
  }, [xmotFormData?.xmotItem]);

  const getTaskTypeValue = (tqItem) => {
    switch (tqItem?.selectedTaskOption) {
      case "general":
        return "text";
      // case "upload_photo_video":
      //   return tqItem?.selectedUploadPhotoType;
      case "capture_photo_video":
        return tqItem?.selectedCaptureType;
      case "screen_capture":
        return "screen_capture";
      case "barcode":
        return "barcode";
      case "view_stimuli":
        return tqItem?.selectedStimuliType;
      default:
        return "";
    }
  };

  const getTaskInstructions = (tqItem) => {
    switch (tqItem?.selectedTaskOption) {
      // case "upload_photo_video":
      //   return tqItem?.uploadPhotoVideoInstructions;
      case "capture_photo_video":
        return tqItem?.captureInstructions;
      case "screen_capture":
        return tqItem?.screenCaptureInstructions;
      case "barcode":
        return tqItem?.barcodeInstructions;
      case "view_stimuli":
        return tqItem?.selectedStimuliType;
      default:
        return tqItem?.instructions;
    }
  };

  const getTaskQuestions = (surveyType) => {
    const taskDataToSend = taskQuestionItems.map((tqItem, i) => {
      const tqCommonPayloadValues = {
        tmp_task_id: tqItem.tId,
        task_id: tqItem?.task_id ? tqItem?.task_id : 0,
        bid: tqItem?.bId || null,
        block_id: tqItem?.block_id || 0,
        block_name: tqItem?.bId
          ? `Randomization Block ${subNumCountingCapital[getRandomizeBlocks?.findIndex((randomizeBlock) => randomizeBlock?.bId === tqItem?.bId) || 0]}`
          : "",
      };
      if (tqItem.type === "task") {
        const taskType = getTaskTypeValue(tqItem);
        const taskInstructions = getTaskInstructions(tqItem);

        // send task camera value if capture_photo_video type selected
        if (tqItem?.selectedTaskOption === "capture_photo_video") {
          tqCommonPayloadValues.task_camera_value =
            tqItem?.captureCameraPosition;
        }

        return {
          ...tqCommonPayloadValues,
          task_type: taskType,
          task_instructions: taskInstructions,
          photo_video_url:
            tqItem?.selectedStimuliType === "photo"
              ? tqItem?.photoUrl
              : tqItem?.videoUrl,
          video_thumbnail:
            tqItem?.selectedStimuliType === "video"
              ? tqItem?.videoThumbnailUrl
              : "",
          name: tqItem?.taskName,
          total_questions:
            tqItem?.subTaskQues?.length > 0 && taskType === "text"
              ? tqItem?.subTaskQues?.length
              : 0,
          task_order: i + 1,
          // task_camera_value: "off",
          taskquestion_duration: tqItem?.taskDuration,
          // session_skip_logic: getSkipLogicPayload(tqItem),
          questions:
            tqItem?.subTaskQues?.length > 0 && taskType === "text"
              ? getQuestionsPayload(tqItem?.subTaskQues, surveyType)
              : [],
        };
      } else {
        return {
          ...tqCommonPayloadValues,
          // task_type: "question",
          task_instructions: "",
          photo_video_url: "",
          study_session_id: finalStudyId,
          video_thumbnail: "",
          name: "",
          total_questions: 1,
          task_order: i + 1,
          // task_camera_value: "off",
          taskquestion_duration: tqItem?.quesDuration,
          questions: getQuestionsPayload([{ ...tqItem }], surveyType),
        };
      }
    });

    return taskDataToSend;
  };

  const getQuestionType = (quesType, scaleValue) => {
    switch (quesType) {
      case "open_ended_question":
        return "open";

      case "multiple_choice_single_select":
        return "option";

      case "multiple_choice_multi_select":
        return "multiselect";

      case "rating_question":
        return `rating_${scaleValue}`;

      case "ranking_question":
        return "ranking";

      default:
        return "";
    }
  };

  const getQuestionTypeFromResponse = (quesType) => {
    switch (quesType) {
      case "open":
        return "open_ended_question";

      case "option":
        return "multiple_choice_single_select";

      case "multiselect":
        return "multiple_choice_multi_select";

      case "rating_5":
        return `rating_question`;

      case "rating_10":
        return `rating_question`;

      case "ranking":
        return "ranking_question";

      default:
        return "";
    }
  };

  const buildSkipLogicPayloadObject = (
    skipLogicJson,
    tqData,
    checkTqOrder,
    tIdValue,
    optionNumber = "",
    rank = "",
  ) => {
    return {
      skip_logic_id: skipLogicJson?.skip_logic_id
        ? skipLogicJson?.skip_logic_id
        : 0,
      tid: tIdValue,
      qid:
        tqData?.question_id === 0
          ? tqData?.qId
          : tqData?.question_id?.toString(),
      option_number: optionNumber,
      jump_task_no: parseInt(
        checkTqOrder?.index !== -1 ? checkTqOrder?.index + 1 : 0,
      ),
      jump_question_no:
        checkTqOrder?.index !== -1 ? checkTqOrder?.subIndexChar : "",
      skip_question_id: skipLogicJson?.skip_question_id?.toString(),
      skip_task_id: skipLogicJson?.skip_task_id?.toString(),
      rank: rank,
      end_session: skipLogicJson?.skipToQuestionId === "1" ? "1" : "0",
    };
  };

  const getCheckTaskQuestionOrder = (skipLogicJson) => {
    return taskQuestionItems.reduce(
      (result, taskQue, index) => {
        const skipId = skipLogicJson?.skipToQuestionId;
        if (taskQue.type === "task") {
          const taskId = taskQue.task_id === 0 ? taskQue.tId : taskQue.task_id;
          if (taskId === skipId) {
            return { index, subIndexChar: "" };
          } else if (taskQue?.subTaskQues?.length > 0) {
            const subTQArr = taskQue?.subTaskQues;
            for (let subIndex = 0; subIndex < subTQArr.length; subIndex++) {
              const subTQ = subTQArr[subIndex];
              const questionId =
                subTQ.question_id === 0 ? subTQ.qId : subTQ.question_id;
              if (questionId === skipId) {
                return { index, subIndexChar: subNumCounting[subIndex] };
              }
            }
          }
        } else {
          const questionId =
            taskQue.question_id === 0 ? taskQue.qId : taskQue.question_id;
          if (questionId === skipId) {
            return { index, subIndexChar: "" };
          }
        }
        return result;
      },
      { index: -1, subIndexChar: "" },
    );
  };

  const getSkipLogicPayloadData = () => {
    return taskQuestionItems.flatMap((tqItem) => {
      const slPayloadData = getSkipLogicPayload(tqItem);
      return slPayloadData.length ? slPayloadData : [];
    });
  };

  const getSkipLogicPayload = (tqData) => {
    let skipLogicPayload = [];
    if (tqData?.type === "task") {
      if (tqData?.subTaskQues?.length === 0) {
        if (tqData?.skipLogic?.length) {
          const skipLogicJson =
            tqData?.skipLogic?.length > 0 ? tqData?.skipLogic[0] : {};
          if (Object.keys(skipLogicJson).length > 0) {
            const checkTqOrder = getCheckTaskQuestionOrder(skipLogicJson);
            const tIdValue =
              tqData?.task_id === 0 ? tqData?.tId : tqData?.task_id?.toString();
            const payloadValue = buildSkipLogicPayloadObject(
              skipLogicJson,
              tqData,
              checkTqOrder,
              tIdValue,
              "",
              "",
            );
            skipLogicPayload.push(payloadValue);
          } else {
            return false;
          }
        }
      } else {
        const subTQArr = tqData?.subTaskQues;
        subTQArr.forEach((subTQData) => {
          if (subTQData?.skipLogic?.length > 0) {
            const skipLogicArr = subTQData?.skipLogic;
            const subSkipLogicPayload = skipLogicArr.map((skipLogicJson) => {
              const checkTqOrder = getCheckTaskQuestionOrder(skipLogicJson);
              const optionNumber =
                skipLogicJson?.selectedOptions &&
                skipLogicJson?.selectedOptions?.length
                  ? skipLogicJson?.selectedOptions
                      ?.map((item) => item)
                      .join(",")
                  : "";
              const rank = skipLogicJson?.selectedRank
                ? skipLogicJson?.selectedRank?.toString()
                : "";
              const tIdValue =
                tqData?.task_id === 0
                  ? tqData?.tId
                  : tqData?.task_id?.toString();
              return buildSkipLogicPayloadObject(
                skipLogicJson,
                subTQData,
                checkTqOrder,
                tIdValue,
                optionNumber,
                rank,
              );
            });
            skipLogicPayload = [...skipLogicPayload, ...subSkipLogicPayload];
          }
        });
      }
    } else {
      if (tqData?.skipLogic?.length > 0) {
        const skipLogicArr = tqData?.skipLogic;
        skipLogicPayload = skipLogicArr.map((skipLogicJson) => {
          const checkTqOrder = getCheckTaskQuestionOrder(skipLogicJson);
          const optionNumber =
            skipLogicJson?.selectedOptions &&
            skipLogicJson?.selectedOptions?.length
              ? skipLogicJson?.selectedOptions?.map((item) => item).join(",")
              : "";
          const rank = skipLogicJson?.selectedRank
            ? skipLogicJson?.selectedRank?.toString()
            : "";
          const tIdValue =
            tqData?.question_id === 0
              ? tqData?.tId
              : tqData?.task_id?.toString();
          return buildSkipLogicPayloadObject(
            skipLogicJson,
            tqData,
            checkTqOrder,
            tIdValue,
            optionNumber,
            rank,
          );
        });
      }
    }
    return skipLogicPayload;
  };

  const getParentExtractionQuestionOptions = (questionData) => {
    const parentQuestion = taskQuestionItems.find(
      (tqItem) =>
        tqItem?.qId === questionData?.extractedQId ||
        tqItem?.question_id === questionData?.extractedQId,
    );

    return (
      parentQuestion?.[parentQuestion?.selectedQuestionOption]?.options
        ?.map((option) => option.value)
        .filter((optionVal) => optionVal !== "") || []
    );
  };

  const getQuestionsPayload = (questionsData, surveyType = "") => {
    const quesPayload = questionsData.map((questionVal, index) => {
      const question = questionVal;
      return {
        tmp_question_id: question.qId,
        question_id: question?.question_id ? question?.question_id : 0,
        // name: `Q${index + 1}`,
        options: question?.isExtraction
          ? getParentExtractionQuestionOptions(question)
          : question[question?.selectedQuestionOption]?.options
              ?.map((option) => option.value)
              .filter((optionVal) => optionVal !== ""),
        question_type: getQuestionType(
          question?.selectedQuestionOption,
          question[question?.selectedQuestionOption]?.selectedScale,
        ),
        answer_type:
          question?.selectedQuestionOption === "open_ended_question" &&
          surveyType === "text"
            ? question[question?.selectedQuestionOption]?.answerType
                ?.selectedType
            : "",
        answer_type_time_option:
          question?.selectedQuestionOption === "open_ended_question" &&
          surveyType === "text" &&
          question[question?.selectedQuestionOption]?.answerType
            ?.selectedType === "time"
            ? parseInt(
                question[question?.selectedQuestionOption]?.answerType
                  ?.selectedValue,
              )
            : 0,
        instructions: question[question?.selectedQuestionOption]?.instructions,
        question: question?.questionName,
        order: index + 1,
        number_type: "",
        taskquestion_duration: question?.quesDuration,
        is_randomized_answer:
          question[question?.selectedQuestionOption]?.randomizeAnsOpt !== null
            ? 1
            : 0,
        not_randomized_last_option:
          question[question?.selectedQuestionOption]?.randomizeAnsOpt !== null
            ? question[question?.selectedQuestionOption]?.randomizeAnsOpt
            : null,
        is_extraction: question?.isExtraction ? 1 : 0,
        extracted_id: question?.extracted_id || 0,
        extracted_qid: question?.extractedQId?.toString() || null,
        extracted_tid: question?.extractedTId?.toString() || null,
        answer_extract_option: question?.selectedExtractedAnsOpt || null,
        // session_skip_logic: getSkipLogicPayload(question)
      };
    });

    return quesPayload;
  };

  const onDeleteTaskQuestion = (tqIDs, deleteType) => {
    const { sessionId } = xmotFormData;
    let requestBody = {
      project_id: parseInt(finalStudyId),
      session_id: sessionId,
    };
    if (deleteType === "deleteAll") {
      requestBody = {
        ...requestBody,
        ...tqIDs,
      };
    } else {
      if (deleteType === "task") {
        requestBody.task_id = tqIDs;
      } else {
        requestBody.question_id = tqIDs;
      }
    }
    setDeleteTQLoading(true);

    return deleteXmotTaskQuestion(token, requestBody)
      .then((response) => {
        if (response?.data?.success === 1) {
          setDeleteTQLoading(false);
          getTriggerDetailsById("deleteType");
          return {
            success: true,
            message: "Task Question Deleted successfully",
          };
        } else {
          setDeleteTQLoading(false);
          showToast({
            severity: "error",
            summary: "Error",
            detail: "Error in Delete Task Question.",
            life: 4000,
          });
          return { success: false, message: "Error in Delete Task Question." };
        }
      })
      .catch((error) => {
        setDeleteTQLoading(false);
        showToast({
          severity: "error",
          summary: "Error",
          detail:
            error?.response?.data?.msg || "Error in Delete Task Question.",
          life: 4000,
        });
        console.error("Error delete Task Question:", error);
        handleError(error, navigate, dispatch);
        return {
          success: false,
          message:
            error?.response?.data?.msg || "Error in Delete Task Question.",
        };
      });
  };

  const onDeleteTaskQuestionBlock = (blockId) => {
    const { sessionId } = xmotFormData;
    let requestBody = {
      project_id: parseInt(finalStudyId),
      session_id: sessionId,
      block_id: blockId,
    };
    setDeleteTQLoading(true);

    return deleteXmotTaskQuestionBlock(token, requestBody)
      .then((response) => {
        if (response?.data?.success === 1) {
          setDeleteTQLoading(false);
          getTriggerDetailsById("deleteType");
          return {
            success: true,
            message: "Task Question Deleted successfully",
          };
        } else {
          setDeleteTQLoading(false);
          showToast({
            severity: "error",
            summary: "Error",
            detail: "Error in Delete Task Question Block.",
            life: 4000,
          });
          return {
            success: false,
            message: "Error in Delete Task Question Block.",
          };
        }
      })
      .catch((error) => {
        setDeleteTQLoading(false);
        showToast({
          severity: "error",
          summary: "Error",
          detail:
            error?.response?.data?.msg ||
            "Error in Delete Task Question Block.",
          life: 4000,
        });
        console.error("Error delete Task Question Block:", error);
        handleError(error, navigate, dispatch);
        return {
          success: false,
          message:
            error?.response?.data?.msg ||
            "Error in Delete Task Question Block.",
        };
      });
  };

  const onDeleteSkipLogic = (skipLogicId) => {
    setDeleteTQLoading(true);

    return deleteSkipLogicTq(token, { skip_logic_id: skipLogicId })
      .then((response) => {
        if (response?.data?.success === 1) {
          setDeleteTQLoading(false);
          getTriggerDetailsById("deleteType");
          return { success: true, message: "Skip Logic Deleted successfully" };
        } else {
          setDeleteTQLoading(false);
          showToast({
            severity: "error",
            summary: "Error",
            detail: "Error in Delete Skip Logic.",
            life: 4000,
          });
          return { success: false, message: "Error in Delete Skip Logic." };
        }
      })
      .catch((error) => {
        setDeleteTQLoading(false);
        showToast({
          severity: "error",
          summary: "Error",
          detail: error?.response?.data?.msg || "Error in Delete Skip Logic.",
          life: 4000,
        });
        console.error("Error delete Skip Logic:", error);
        handleError(error, navigate, dispatch);
        return {
          success: false,
          message: error?.response?.data?.msg || "Error in Delete Skip Logic.",
        };
      });
  };

  const tabsData = [
    {
      header: "XMOT Info",
      icon: "pi pi-align-justify pe-2 fs-20",
      disabled: false,
      content: (
        <XmotInfoStep
          errors={xmotInfoErrors}
          categoryData={categoryData}
          xmotFormData={xmotFormData}
          handleXmotFormChange={handleXmotFormChange}
          finalStudyId={finalStudyId}
          trigger_type={triggerType}
          setIsThersholdErr={setIsThersholdErr}
          categoryId={categoryId}
          mappedCategory={mappedCategory}
          isEditMode={isEditMode}
          customRecruits={customRecruits}
          loading={loading}
          isLocked={isLocked}
          updateThresholdValuesInForm={updateThresholdValuesInForm}
          isLogicSettingsError={isLogicSettingsError}
        />
      ),
    },
    {
      header: "XMOT Timeline & Reminders",
      icon: "pi pi-stopwatch pe-2 fs-20",
      disabled: !completedSteps.includes(0),
      content: (
        <TimelineAndReminder
          errors={timelineAndReminderErrors}
          handleErrors={(inputField, inputValue) =>
            setTimelineAndReminderErrors((prev) => ({
              ...prev,
              [inputField]: inputValue,
            }))
          }
          categoryData={categoryData}
          xmotFormData={xmotFormData}
          handleXmotFormChange={handleXmotFormChange}
          durationUnitOptions={durationUnitOptions}
          loading={loading}
          isLocked={isLocked}
          stopXmotCreditValue={stopXmotCreditValue}
        />
      ),
    },
    {
      header: "Participants",
      icon: "pi pi-users pe-2 fs-20",
      disabled: !completedSteps.includes(1),
      content: (
        <Participants
          errors={participantsErrors}
          categoryData={categoryData}
          xmotFormData={xmotFormData}
          handleXmotFormChange={handleXmotFormChange}
          finalStudyId={finalStudyId}
          trigger_type={triggerType}
          mappedCategory={mappedCategory}
          isEditMode={isEditMode}
          loading={loading}
          isLocked={isLocked}
        />
      ),
    },
    {
      header: "Instruction & Task/Questions",
      icon: "pi pi-copy pe-2 fs-20",
      disabled: !completedSteps.includes(2),
      content: (
        <InstructionsAndTaskQuestion
          errors={instructionAndTQErrors}
          xmotFormData={xmotFormData}
          handleXmotFormChange={handleXmotFormChange}
          setTaskQuestionItems={setTaskQuestionItems}
          taskQuestionItems={taskQuestionItems}
          clientId={
            user?.type === "superadmin" ? parseInt(id) : parseInt(user?.id)
          }
          projectId={finalStudyId}
          token={token}
          trigger_type={triggerType}
          deleteTQLoading={deleteTQLoading}
          onDeleteTaskQuestion={onDeleteTaskQuestion}
          onDeleteSkipLogic={onDeleteSkipLogic}
          onDeleteTaskQuestionBlock={onDeleteTaskQuestionBlock}
          loading={loading}
          isLocked={isLocked}
        />
      ),
    },
    {
      header: "Credits",
      icon: "pi pi-credit-card pe-2 fs-20",
      disabled: !completedSteps.includes(3),
      content: (
        <Credits
          xmotFormData={xmotFormData}
          handleXmotFormChange={handleXmotFormChange}
          loading={loading}
          isLocked={isLocked}
        />
      ),
    },
  ];

  const getTimeDayPipeValues = (dataValues) => {
    if (dataValues && dataValues.length === 0) {
      return "";
    } else {
      return dataValues.join(" | ");
    }
  };

  const handleStepSave = (requestBody, stepUrl, submitType = "not-publish") => {
    if (
      (requestBody?.trigger_usage_xyz_threshold_magnitude === null ||
        requestBody?.trigger_session_seconds === null) &&
      user?.type === "superadmin"
    ) {
      setIsLogicSettingsError(true);
      return;
    }
    setIsLogicSettingsError(false);
    setLoading(true);
    saveXMOTSurvey(token, requestBody, stepUrl)
      .then((response) => {
        if (response?.data?.success === 1) {
          setLoading(false);
          if (submitType === "publish") {
            navigate(
              `/admin-panel/survey/fromClient-${user?.type === "superadmin" ? parseInt(id) : parseInt(user?.id)}`,
            );
          } else {
            handleXmotFormChange("sessionId", response?.data?.sessionId);
            handleXmotFormChange("triggerId", response?.data?.triggerId);

            // Handle Xmot task question edit in create xmot when at step 5 & refresh case on reload while create xmot
            if (isEmptyCheck(storeTriggerId) || isEmptyCheck(storeSessionId)) {
              dispatch({
                type: SET_SELECTED_SURVEY_CATEGORY,
                payload: {
                  ...selectedSurveyCategory,
                  sessionId: response?.data?.sessionId,
                  triggerId: response?.data?.triggerId,
                  studyId: finalStudyId,
                },
              });
            }

            if (!completedSteps.includes(activeIndex)) {
              setCompletedSteps([...completedSteps, activeIndex]);
            }
            setActiveIndex(activeIndex + 1);
            setMaxCompletedStep(response?.data?.xmot_steps);
          }
        } else {
          setLoading(false);
          showToast({
            severity: "error",
            summary: "Error",
            detail: response?.data?.error || "Error in save Xmot.",
            life: 4000,
          });
        }
      })
      .catch((error) => {
        if (
          error?.response?.data?.error?.toLowerCase() ===
          productAlreadyUsedErrMsg?.toLocaleLowerCase()
        ) {
          showToast({
            severity: "error",
            content: (
              <div className="text-start fs-14">
                <div className="fw-600">
                  Another XMOT is currently active for this product.
                </div>
                <p className="mt-1">
                  Only one XMOT per product can run at a time. Save this as a
                  draft and publish it once the other XMOT ends. Contact your
                  QualSights team if you have questions.
                </p>
              </div>
            ),
            life: 5000,
          });
        } else {
          showToast({
            severity: "error",
            summary: "Error",
            detail: error?.response?.data?.error || "Error in save Xmot.",
            life: 4000,
          });
        }
        setLoading(false);
        handleError(error, navigate, dispatch);
        console.error("Error fetching categories:", error);
      });
  };

  // const handleSave = (saveType) => {
  //   const { reminder, surveyName, survey, xmotItem, selectedDropdownValue, timeline, participants, instructions, sessionDurationTime, thresholdMagnitudeValue } = xmotFormData;

  //   const requestBody = {
  //     category_type: "tag",
  //     client_id: user?.type === "superadmin" ? parseInt(id) : parseInt(user?.id),
  //     project_id: finalStudyId,
  //     trigger_name: surveyName,
  //     session_type: survey,
  //     trigger_product_type: xmotItem,
  //     study_id: finalStudyId,
  //     tag_products_id: selectedDropdownValue,
  //     trigger_xmot_type: parseInt(timeline.timelineSelection),
  //     trigger_xmot_onetime_type: parseInt(timeline?.trigger_xmot_onetime_type),
  //     trigger_xmot_onetime_time: getTimeDayPipeValues(timeline?.productUsedWithCondition?.selectedDayConditionValue),
  //     trigger_xmot_onetime_day: getTimeDayPipeValues(timeline?.productUsedWithCondition?.selectedWeekConditionValue),
  //     xmot_stop_on: timeline?.stopXmotBasedOn,
  //     xmot_stop_credit_limit: timeline?.stopXmotBasedOn === 1 ? stopXmotValue : null,
  //     xmot_stop_part_limit: timeline?.stopXmotBasedOn === 2 ? stopXmotValue : null,
  //     xmot_stop_date: timeline?.stopXmotBasedOn === 3 ? stopXmotValue : null,
  //     trigger_window_length: timeline.windowLength,
  //     trigger_session_expire_value: parseInt(timeline?.durationUnit),
  //     trigger_session_expire_unit: timeline?.expireDuration,
  //     trigger_timeline_type: timeline?.triggerTimelineType || null,
  //     trigger_timeline_value: timeline?.triggerTimelineValue || null,
  //     reminder_text: reminder?.reminderText,
  //     reminder_on_off: reminder?.reminderSwitch ? 1 : 0,
  //     trigger_reminder_unit: parseInt(reminder?.reminderTypeUnitValue),
  //     trigger_reminder_value_in_hours: reminder?.reminderTime,
  //     trigger_reminder_type: parseInt(reminder?.reminderTypeValue),
  //     xmot_gender: participants?.selectedGender,
  //     xmot_age_range: participants?.selectedAgeRange,
  //     xmot_brand: participants?.selectedBrand,
  //     participant_type: participants?.participantsValues?.map(item => item).join(","),
  //     assign_to_participant: participants?.participantsValues?.map(item => item).join(","),
  //     session_instruction: instructions,
  //     tasks: getTaskQuestions(),
  //     //extra parameters
  //     trigger_type: "xmot",
  //     trigger_usage_xyz_threshold_magnitude: thresholdMagnitudeValue,
  //     xmot_participant: "active",
  //     session_status_for_app: "active",
  //     trigger_push_notification_text: getTriggerPushNotificationText(xmotItem),
  //     session_category: "text",
  //     session_type_details: "recorded",
  //     session_type_value_details: "qualsights_survey",
  //     session_type: "recorded",
  //     is_trigger_session: 1,
  //     is_coaster_trigger_session: 0,
  //     assign_to_participant: 1,
  //     session_status_for_app: "active",
  //     xmot_client_id: user?.type === "superadmin" ? parseInt(id) : parseInt(user?.id),
  //     xmot_draft: saveType === "draft" ? 1 : 0,
  //     session_duration: sessionDurationTime
  //   };

  //   console.log("requestBody", requestBody);
  //   return false;

  //   saveXMOTSurvey(token, requestBody).then((response) => {
  //     if (response?.data?.success === 1) {
  //       showToast({
  //         severity: "success",
  //         summary: "Success",
  //         detail: "Xmot created Successfully.",
  //         life: 3000
  //       });
  //       navigate(`/admin-panel/survey/fromClient-${user?.type === "superadmin" ? parseInt(id) : parseInt(user?.id)}`);
  //     } else {
  //       showToast({
  //         severity: "error",
  //         summary: "Error",
  //         detail: "Error in save Xmot.",
  //         life: 4000
  //       });
  //     }
  //   }).catch((error) => {
  //     console.log("error", error?.response?.data?.msg)
  //     showToast({
  //       severity: "error",
  //       summary: "Error",
  //       detail: error?.response?.data?.msg || "Error in save Xmot.",
  //       life: 4000
  //     });
  //     console.error("Error fetching categories:", error);
  //   });
  // };

  const getCategoryForXMOT = () => {
    const reqBody = {
      client_id:
        user?.type === "superadmin" ? parseInt(id) : parseInt(user?.id),
    };
    getCategoriesForXMOT(token, reqBody)
      .then((response) => {
        if (response.status === 200) {
          const categories = response.data.data;
          setCategoryData(categories);

          // Check if there's only one category and set selectedCategory accordingly
          if (categories.length === 1) {
            const singleCategory = categories[0];
            setSelectedCategory(
              `${singleCategory.category_id}-${singleCategory.study_id}-${singleCategory.category_type}`,
            );
            // setSelectedStudy(singleCategory.study_id);
            // setSelectedTriggerType(singleCategory.category_type);
          } else {
            setSelectedCategory(""); // Reset if there are multiple categories
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  };

  const getInstructionDefaultValue = (triggerType, itemName = "") => {
    switch (triggerType) {
      case "tag":
        return `We detected activity from your tagged ${itemName}. Please complete this short activity to share details about what happened.`;
      case "coaster":
        return `We detected activity from the ${itemName} on your Smart Coaster. Please complete this short activity to share details about what happened.`;
      default:
        return "";
    }
  };

  const fillSkipLogicData = (taskQues, fillType) => {
    if (fillType === "task" || fillType === "open_ended_question") {
      const skipLogicValues = taskQues?.session_skip_logic;
      const skipLogicValue = skipLogicValues[0];
      let slCommonJson;
      if (skipLogicValue?.end_session === "1") {
        slCommonJson = {
          name: "You have completed all Tasks/Questions",
          skipToQuestionId: skipLogicValue?.end_session,
          skip_task_id: "end_session",
          skip_question_id: "end_session",
        };
      } else {
        slCommonJson = {
          name: `${skipLogicValue?.jump_task_no}. ${skipLogicValue?.skip_task_name || skipLogicValue?.skip_question_name}`,
          skipToQuestionId:
            skipLogicValue?.skip_question_id === 0
              ? skipLogicValue?.skip_task_id
              : skipLogicValue?.skip_question_id,
          skip_task_id: skipLogicValue?.skip_task_id,
          skip_question_id:
            skipLogicValue?.skip_question_id === 0
              ? undefined
              : skipLogicValue?.skip_question_id,
        };
      }
      return [
        {
          skip_logic_id: skipLogicValue?.id,
          ...slCommonJson,
        },
      ];
    } else {
      const skipLogicValues = taskQues?.session_skip_logic;
      return skipLogicValues.map((skipLogicValue, _) => {
        if (skipLogicValue?.end_session === "1") {
          let slCommonJson = {
            name: "You have completed all Tasks/Questions",
            skipToQuestionId: skipLogicValue?.end_session,
            skip_task_id: "end_session",
            skip_question_id: "end_session",
          };
          slCommonJson = {
            skip_logic_id: skipLogicValue?.id,
            optionIndex: parseInt(skipLogicValue?.skip_option_selected),
            selectedRank: parseInt(skipLogicValue?.rank_value) || "",
            selectedOptions: isEmptyCheck(skipLogicValue?.skip_option_selected)
              ? ""
              : fillType === "multiple_choice_multi_select"
                ? skipLogicValue?.skip_option_selected
                    ?.split("_")
                    .filter(Boolean)
                    .map(Number)
                : skipLogicValue?.skip_option_selected
                    ?.split(",")
                    .map((v) => parseInt(v.trim(), 10)),
            ...slCommonJson,
          };
          return slCommonJson;
        } else {
          return {
            skip_logic_id: skipLogicValue?.id,
            name: `${skipLogicValue?.jump_task_no}. ${skipLogicValue?.skip_task_name || skipLogicValue?.skip_question_name}`,
            skipToQuestionId:
              skipLogicValue?.skip_question_id === 0
                ? skipLogicValue?.skip_task_id
                : skipLogicValue?.skip_question_id,
            skip_task_id: skipLogicValue?.skip_task_id,
            skip_question_id:
              skipLogicValue?.skip_question_id === 0
                ? undefined
                : skipLogicValue?.skip_question_id,
            optionIndex: parseInt(skipLogicValue?.skip_option_selected),
            selectedRank: parseInt(skipLogicValue?.rank_value) || "",
            selectedOptions: isEmptyCheck(skipLogicValue?.skip_option_selected)
              ? ""
              : fillType === "multiple_choice_multi_select"
                ? skipLogicValue?.skip_option_selected
                    ?.split("_")
                    .filter(Boolean)
                    .map(Number)
                : skipLogicValue?.skip_option_selected
                    ?.split(",")
                    .map((v) => parseInt(v.trim(), 10)),
          };
        }
      });
    }
  };

  const getSelectedTaskOption = (taskQues) => {
    switch (taskQues?.task_type) {
      case "text":
        return "general";

      case "photo":
      case "video":
        return "view_stimuli";

      // case "upload_photo":
      // case "upload_video":
      //   return "upload_photo_video";

      case "capture_photo":
      case "capture_video":
        return "capture_photo_video";

      case "screen_capture":
      case "barcode":
        return taskQues?.task_type;

      default:
        return "text";
    }
  };

  const makeTaskQuesEditData = (taskQuesData) => {
    if (taskQuesData.length > 0) {
      const mappedTQData = taskQuesData.map((taskQues, index) => {
        const tqType = taskQues?.name !== "" ? "task" : "question";
        // task type will name value filled so consider as task(no specific type coming from the backend)
        if (taskQues?.name !== "") {
          let taskFilledItem = {
            task_id: taskQues?.id,
            tId: taskQues?.id?.toString(),
            type: tqType,
            isSelected: false,
            taskName: taskQues?.name,
            selectedTaskOption: getSelectedTaskOption(taskQues),
            selectedStimuliType:
              taskQues?.task_type === "video" ? "video" : "photo",
            instructions: ["photo", "video"].includes(taskQues?.task_type)
              ? taskQues?.task_instructions
              : "Tap on the thumbnail to view in full screen",
            selectedUploadPhotoType:
              taskQues?.task_type === "upload_video"
                ? "upload_video"
                : "upload_photo",
            uploadPhotoVideoInstructions: [
              "upload_photo",
              "upload_video",
            ].includes(taskQues?.task_type)
              ? taskQues?.task_instructions
              : "Please upload photo(s) using the button provided",
            selectedCaptureType:
              taskQues?.task_type === "capture_video"
                ? "capture_video"
                : "capture_photo",
            captureCameraPosition: taskQues?.task_camera_value
              ? taskQues?.task_camera_value
              : "0",
            captureInstructions: ["capture_photo", "capture_video"].includes(
              taskQues?.task_type,
            )
              ? taskQues?.task_instructions
              : "Please take photo(s) using the button provided",
            screenCaptureInstructions:
              taskQues?.task_type === "screen_capture"
                ? taskQues?.task_instructions
                : "Please take photo(s) using the button provided",
            barcodeInstructions:
              taskQues?.task_type === "barcode"
                ? taskQues?.task_instructions
                : "Please take photo(s) using the button provided",
            subTaskQues: [],
            taskDuration: taskQues?.taskquestion_duration,
            skipLogic: taskQues?.session_skip_logic?.length
              ? fillSkipLogicData(taskQues, tqType)
              : [],
            isError: false,
            errormsg: "",
            photoUrl:
              taskQues?.task_type === "photo" ? taskQues?.photo_video_url : "",
            videoThumbnailUrl:
              taskQues?.task_type === "video" ? taskQues?.video_thumbnail : "",
            videoUrl:
              taskQues?.task_type === "video" ? taskQues?.photo_video_url : "",
            stimuliInstructionErrormsg: "",
            imgUploadErr: "",
            imgFile: null,
            isImageUploading: false,
            isImageUploaded:
              taskQues?.task_type === "photo" &&
              taskQues?.photo_video_url !== ""
                ? true
                : false,
            videoUploadErr: "",
            videoThumbUploadErr: "",
            videoFile: null,
            isVideoUploading: false,
            isVideoUploaded:
              taskQues?.task_type === "video" &&
              taskQues?.photo_video_url !== ""
                ? true
                : false,
            videoThumbnailFile: null,
            isVideoThumbUploading: false,
            isVideoThumbUploaded:
              taskQues?.task_type === "video" &&
              taskQues?.video_thumbnail !== ""
                ? true
                : false,
            block_name: taskQues?.block_name,
            block_id: taskQues?.block_id === 0 ? null : taskQues?.block_id,
            bId:
              taskQues?.block_id === 0 ? null : taskQues?.block_id?.toString(),
          };

          if (taskQues?.questions?.length > 0) {
            const subTaskQuesItems = taskQues?.questions.map((subQues, _i) => {
              return {
                isSubTQSelected: false,
                ...fillQuestionValues(taskQues, subQues),
              };
            });
            taskFilledItem.subTaskQues = subTaskQuesItems;
          } else {
            taskFilledItem.subTaskQues = [];
          }

          return taskFilledItem;
        } else {
          const questionValues =
            taskQues?.questions?.length > 0 ? taskQues?.questions[0] : {};
          return {
            ...fillQuestionValues(taskQues, questionValues),
          };
        }
      });

      setTaskQuestionItems(mappedTQData);
    } else {
      setTaskQuestionItems([]);
    }
  };

  const fillQuestionValues = (taskQues, questionData) => {
    let filledQuesValues = {
      block_name: taskQues?.block_name,
      block_id: taskQues?.block_id === 0 ? null : taskQues?.block_id,
      bId: taskQues?.block_id === 0 ? null : taskQues?.block_id?.toString(),
      question_id: questionData?.id,
      task_id: taskQues?.id,
      tId: taskQues?.id?.toString(),
      qId: questionData?.id?.toString(),
      type: "question",
      isSelected: false,
      quesDuration: questionData?.taskquestion_duration,
      questionName: he.decode(questionData?.question),
      selectedQuestionOption: getQuestionTypeFromResponse(
        questionData?.question_type,
      ),
      isError: false,
      errormsg: "",
      multiple_choice_single_select: {
        options: genDefAnswerOptions(),
        instructions: "Please explain verbally",
        isInstructionError: false,
        instructionErrormsg: "",
        randomizeAnsOpt: null,
        isBulkAdd: false,
        bulkAddText: "",
      },
      open_ended_question: {
        instructions: "Please explain verbally",
        isInstructionError: false,
        instructionErrormsg: "",
        answerTypeError: "",
        answerType: {
          selectedType: "text",
          selectedValue: 1,
        },
      },
      multiple_choice_multi_select: {
        options: genDefAnswerOptions(),
        instructions: "Please explain verbally",
        isInstructionError: false,
        instructionErrormsg: "",
        randomizeAnsOpt: null,
        isBulkAdd: false,
        bulkAddText: "",
      },
      rating_question: {
        instructions: "With 5 being the best",
        isInstructionError: false,
        instructionErrormsg: "",
        selectedScale: "5",
      },
      ranking_question: {
        options: genDefAnswerOptions(),
        instructions: "Tap on the options to set your preferred order",
        isInstructionError: false,
        instructionErrormsg: "",
        isBulkAdd: false,
        bulkAddText: "",
      },
      skipLogic: questionData?.session_skip_logic?.length
        ? fillSkipLogicData(
            questionData,
            getQuestionTypeFromResponse(questionData?.question_type),
          )
        : [],
    };

    if (questionData?.question_type === "open") {
      filledQuesValues.open_ended_question = {
        instructions: he.decode(questionData?.instructions),
        isInstructionError: false,
        instructionErrormsg: "",
        answerTypeError: "",
        answerType: {
          selectedType: questionData?.answer_type,
          selectedValue: questionData?.answer_type_time_option,
        },
      };
    }

    if (questionData?.question_type === "multiselect") {
      filledQuesValues.multiple_choice_multi_select = {
        options: genDefAnswerOptions(questionData?.options),
        instructions: he.decode(questionData?.instructions),
        isInstructionError: false,
        instructionErrormsg: "",
        randomizeAnsOpt: questionData?.is_randomized_answer
          ? questionData?.not_randomized_last_option
          : null,
        isBulkAdd: false,
        bulkAddText: "",
      };
    }

    if (questionData?.question_type === "option") {
      filledQuesValues.multiple_choice_single_select = {
        options: genDefAnswerOptions(questionData?.options),
        instructions: he.decode(questionData?.instructions),
        isInstructionError: false,
        instructionErrormsg: "",
        randomizeAnsOpt: questionData?.is_randomized_answer
          ? questionData?.not_randomized_last_option
          : null,
        isBulkAdd: false,
        bulkAddText: "",
      };
    }

    if (questionData?.question_type?.includes("rating")) {
      filledQuesValues.rating_question = {
        instructions: he.decode(questionData?.instructions),
        isInstructionError: false,
        instructionErrormsg: "",
        selectedScale: questionData?.question_type.match(/\d+$/)[0],
      };
    }

    if (questionData?.question_type === "ranking") {
      filledQuesValues.ranking_question = {
        options: genDefAnswerOptions(questionData?.options),
        instructions: he.decode(questionData?.instructions),
        isInstructionError: false,
        instructionErrormsg: "",
        isBulkAdd: false,
        bulkAddText: "",
      };
    }

    if (questionData?.is_extraction) {
      filledQuesValues.isExtraction =
        questionData?.is_extraction === 1 ? true : false;
      filledQuesValues.extracted_id = questionData?.extracted_id || null;
      filledQuesValues.extractedQId = questionData?.extracted_qid || null;
      filledQuesValues.extractedTId = questionData?.extracted_tid || null;
      filledQuesValues.selectedExtractedAnsOpt =
        questionData?.answer_extract_option || null;
      filledQuesValues.selectedTargetQuesType = getQuestionTypeFromResponse(
        questionData?.question_type,
      );
    }

    return filledQuesValues;
  };

  const fillEditInstructions = (instructionsData, productName) => {
    if (!isEmptyCheck(instructionsData)) {
      let filledInstructions = instructionsData;
      return filledInstructions;
    }
    return getInstructionDefaultValue(triggerType, productName);
  };

  const getTriggerDetailsById = (type = "") => {
    const reqBody = {
      trigger_id: storeTriggerId || xmotFormData?.triggerId,
    };
    setLoading(true);

    //removing all error while getting data in every tab
    setXmotInfoErrors({});
    setTimelineAndReminderErrors({});
    setInstructionAndTQErrors({});

    getTriggerDetailsDataById(token, reqBody)
      .then((response) => {
        setLoading(false);
        if (
          response.status === 200 &&
          response?.data &&
          response?.data?.success === 1
        ) {
          const customRecruitValue = response?.data?.customRecruit || {};
          const sessionIdValue = response?.data?.sessionData?.id;
          const triggerIdValue = response?.data?.triggerData?.id;
          const triggerData = {
            ...response?.data?.sessionData,
            ...response?.data?.triggerData,
          };
          const participantFilters = response?.data?.filterVariable;
          const taskDataValues = response?.data?.taskData;
          const xmotParticipants = response?.data?.participants;
          const xmotDraft = response?.data?.xmot_draft ? true : false;
          const stepsArray = Array.from(
            { length: triggerData?.xmot_steps },
            (_, i) => i,
          );
          setCompletedSteps(stepsArray);
          setMaxCompletedStep(triggerData?.xmot_steps);
          setIsXmotDraft(xmotDraft);
          if (type === "deleteType") {
            setActiveIndex(activeIndex); //stay on same index when delete action perform on Task/Question
          } else {
            if (
              isEditMode &&
              triggerData?.xmot_steps === 5 &&
              response?.data?.xmot_draft === 0
            ) {
              // setActiveIndex(0); // not required
              // setIsLocked(true);
            } else {
              // Handle Xmot task question edit in create xmot when at step 5
              if (
                !isEmptyCheck(storeTriggerId) &&
                !isEmptyCheck(storeSessionId) &&
                activeIndex < maxCompletedStep
              ) {
                setActiveIndex(activeIndex);
              } else {
                setActiveIndex(triggerData?.xmot_steps);
              }
            }
          }

          let xmotFormFilledData = {
            triggerId: triggerIdValue,
            sessionId: sessionIdValue,
            seletedCustomRecruit: customRecruits.length
              ? customRecruits.find(
                  (data) => data.recruit_id === triggerData?.xmot_recruit_id,
                )
              : "",
            surveyName: triggerData?.trigger_name,
            surveyType: triggerData?.session_category,
            xmotItem: triggerData?.trigger_product_type,
            selectedDropdownValue: triggerData?.tag_products_id,
            cameraTypeOption: triggerData?.camera_value,
            photoTypeOption: triggerData?.session_type_value_details,
            trigger_usage_default_x: triggerData?.trigger_usage_default_x,
            trigger_usage_default_y: triggerData?.trigger_usage_default_y,
            trigger_usage_default_z: triggerData?.trigger_usage_default_z,
            trigger_session_seconds: triggerData?.trigger_session_seconds,
            send_motion: parseInt(triggerData?.send_motion),
            send_motion_seconds: triggerData?.send_motion_seconds,
            send_motion_unit: triggerData?.send_motion_unit,
            reminder: {
              reminderSwitch: triggerData?.reminder_on_off === 1 ? true : false,
              sendReminderToggler:
                triggerData?.trigger_reminder_type === 1 ? true : false,
              reminderTypeUnitValue:
                triggerData?.trigger_reminder_unit === 0
                  ? everyReminderTypeUnit[0].code
                  : triggerData?.trigger_reminder_unit,
              reminderTypeValue:
                triggerData?.trigger_reminder_type === 0
                  ? reminderType[0].code
                  : triggerData?.trigger_reminder_type,
              reminderTime: triggerData?.trigger_reminder_value_in_hours,
              reminderText: isEmptyCheck(triggerData?.reminder_text)
                ? reminderTextValue
                : triggerData?.reminder_text,
            },
            timeline: {
              timelineSelection: triggerData?.trigger_xmot_type,
              windowLength: triggerData?.trigger_window_length,
              expireDuration:
                triggerData?.trigger_session_expire_value === 0
                  ? 4
                  : triggerData?.trigger_session_expire_value,
              durationUnit:
                triggerData?.trigger_session_expire_unit === 0
                  ? durationUnitOptions[0].code
                  : triggerData?.trigger_session_expire_unit,
              nextTimeProductUsed:
                triggerData?.trigger_xmot_onetime_type === 1
                  ? "next_time_product_used"
                  : "next_time_product_used_with_condition",
              trigger_xmot_onetime_type: triggerData?.trigger_xmot_onetime_type,
              noOfUsageEvent:
                triggerData?.trigger_xmot_type === 2
                  ? triggerData?.trigger_timeline_value
                  : null,
              noOfTimeProductUsed:
                triggerData?.trigger_xmot_type === 2 &&
                (triggerData?.trigger_timeline_type === 1 ||
                  triggerData?.trigger_timeline_type === 2 ||
                  triggerData?.trigger_timeline_type === 3)
                  ? triggerData?.trigger_timeline_value
                  : 1,
              typeOfProductUsed:
                triggerData?.trigger_xmot_type === 2 &&
                (triggerData?.trigger_timeline_type === 1 ||
                  triggerData?.trigger_timeline_type === 2 ||
                  triggerData?.trigger_timeline_type === 3)
                  ? triggerData?.trigger_timeline_type
                  : 1,
              triggerTimelineType: triggerData?.trigger_timeline_type,
              triggerTimelineValue: triggerData?.trigger_timeline_value,
              productUsedWithCondition: {
                selectedDayConditionValue: !isEmptyCheck(
                  triggerData?.trigger_xmot_onetime_time,
                )
                  ? triggerData?.trigger_xmot_onetime_time
                      .split("|")
                      .map((item) => item.trim())
                  : [],
                selectedWeekConditionValue: !isEmptyCheck(
                  triggerData?.trigger_xmot_onetime_day,
                )
                  ? triggerData?.trigger_xmot_onetime_day
                      .split("|")
                      .map((item) => item.trim())
                  : [],
              },
              stopXmotBasedOn: triggerData?.xmot_stop_on,
              stopXmotValue:
                triggerData?.xmot_stop_on === 1
                  ? triggerData?.xmot_stop_credit_limit
                  : triggerData?.xmot_stop_on === 2
                    ? triggerData?.xmot_stop_part_limit
                    : triggerData?.xmot_stop_date,
              xmotLimitType: isEmptyCheck(triggerData?.xmot_limit_type)
                ? perParticipantOptions[0]?.code
                : triggerData?.xmot_limit_type,
            },
            participants: {
              selectedSegment:
                participantFilters?.segments !== ""
                  ? participantFilters?.segments
                      ?.split(",")
                      .map((item) => item.trim())
                  : "",
              selectedGender: participantFilters?.gender,
              selectedAgeRange:
                participantFilters?.age !== ""
                  ? participantFilters?.age
                      ?.split(",")
                      .map((item) => item.trim())
                  : "",
              selectedBrand:
                participantFilters?.brand !== ""
                  ? participantFilters?.brand
                      ?.split(",")
                      .map((item) => item.trim())
                  : "",
              participantsValues:
                xmotParticipants !== ""
                  ? xmotParticipants?.split(",").map((item) => parseInt(item))
                  : "",
            },
            instructions: fillEditInstructions(
              triggerData?.instructions,
              customRecruitValue?.product_name || "",
            ),
            taskQuestion: "",
            expectedDuration: "",
            expectedSessionDuration: getExpectedStringTime(
              triggerData?.session_duration,
            ),
            sessionDurationTime: triggerData?.session_duration,
            thresholdMagnitudeValue:
              triggerData?.trigger_usage_xyz_threshold_magnitude,
          };
          setXmotFormData(xmotFormFilledData);

          if (triggerData?.xmot_stop_on === 1) {
            setStopXmotCreditValue(triggerData?.xmot_stop_credit_limit);
          }

          makeTaskQuesEditData(taskDataValues);
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, navigate, dispatch);
        console.error("Error fetching categories:", error);
      });
  };

  useEffect(() => {
    getCategoryForXMOT();

    if (studyId === "" || !!studyId === false || finalStudyId !== studyId) {
      const clientIdVal =
        user?.type === "superadmin" ? parseInt(id) : parseInt(user?.id);
      navigate(`/admin-panel/survey/fromClient-${clientIdVal}`);
    }

    if (
      isEditMode ||
      (!isEmptyCheck(storeTriggerId) && !isEmptyCheck(storeSessionId))
    ) {
      getTriggerDetailsById();
    }
  }, []);

  useEffect(() => {
    // Handle Xmot task question edit in  xmot when at step 5
    if (
      !isEmptyCheck(storeTriggerId) &&
      !isEmptyCheck(storeSessionId) &&
      activeIndex <= maxCompletedStep
    ) {
      getTriggerDetailsById();
    }
  }, [activeIndex]);

  useEffect(() => {
    if (xmotFormData?.surveyType) {
      let newReminderText = "";
      switch (xmotFormData.surveyType) {
        case "text":
          newReminderText =
            "Reminder - please complete this usage survey session as soon as you can.";
          break;
        case "video":
          newReminderText =
            "Reminder - please complete this usage video session as soon as you can.";
          break;
        case "audio":
          newReminderText =
            "Reminder - please complete this usage audio session as soon as you can.";
          break;
        case "photo":
          newReminderText =
            "Reminder - please complete this usage photo session as soon as you can.";
          break;
        default:
          newReminderText =
            "Reminder - please complete this usage survey session as soon as you can.";
      }
      handleXmotFormChange("reminder", {
        ...xmotFormData.reminder,
        reminderText: newReminderText,
      });
    }
  }, [xmotFormData?.surveyType]);

  useEffect(() => {
    if (triggerType === "coaster" && !isEditMode) {
      const itemName = xmotFormData?.seletedCustomRecruit?.product_name || "";
      setXmotFormData((prev) => ({
        ...prev,
        instructions: getInstructionDefaultValue(triggerType, itemName),
      }));
    }
    if (triggerType === "tag" && !isEditMode) {
      const itemName = xmotFormData?.seletedCustomRecruit?.product_name || "";
      setXmotFormData((prev) => ({
        ...prev,
        instructions: getInstructionDefaultValue(triggerType, itemName),
      }));
    }
  }, [triggerType, xmotFormData.xmotItem, activeIndex]);

  const validateXmotInfo = () => {
    let formErrors = {};
    let valid = true;

    if (!xmotFormData?.seletedCustomRecruit) {
      formErrors.seletedCustomRecruit = "Custom Recruit selection is required";
      valid = false;
    }
    if (!xmotFormData?.surveyName) {
      formErrors.surveyName = "Survey Xmot Name is required";
      valid = false;
    }
    if (!xmotFormData?.surveyType) {
      formErrors.surveyType = "Survey Type selection is required";
      valid = false;
    }
    if (!xmotFormData?.xmotItem) {
      formErrors.xmotItem = "XMOT item is required";
      valid = false;
    }
    if (!xmotFormData?.selectedDropdownValue) {
      formErrors.selectedDropdownValue = "Product selection is required";
      valid = false;
    }

    setXmotInfoErrors(formErrors);
    return valid;
  };

  const validateParticipants = () => {
    let formErrors = {};
    let valid = true;

    if (!xmotFormData?.participants?.selectedSegment) {
      formErrors.selectedSegment = "Participants Segment selection is required";
      valid = false;
    }
    if (!xmotFormData?.participants?.selectedGender) {
      formErrors.selectedGender = "Participant Gender is required";
      valid = false;
    }
    if (!xmotFormData?.participants?.selectedAgeRange) {
      formErrors.selectedAgeRange =
        "Participant Age Range selection is required";
      valid = false;
    }
    if (!xmotFormData?.participants?.selectedBrand) {
      formErrors.selectedBrand = "Participant Brand Selection is required";
      valid = false;
    }

    setParticipantsErrors(formErrors);
    return valid;
  };

  const validateTimelineAndReminder = () => {
    let formErrors = {};
    let valid = true;

    if (!xmotFormData?.timeline?.timelineSelection) {
      formErrors.timelineSelection = "Please choose timeline";
      valid = false;
    }
    if (xmotFormData?.timeline?.timelineSelection) {
      // one time selection validations
      if (xmotFormData?.timeline?.timelineSelection === 1) {
        if (!xmotFormData?.timeline?.nextTimeProductUsed) {
          formErrors.nextTimeProductUsed =
            "Please choose Next Time Product Used Option";
          valid = false;
        }
        if (xmotFormData?.timeline?.nextTimeProductUsed) {
          if (!xmotFormData?.timeline?.windowLength) {
            formErrors.windowLength = "Please add window length";
            valid = false;
          }
          if (!xmotFormData?.timeline?.expireDuration) {
            formErrors.expireDuration = "Please add Expire Duration";
            valid = false;
          }
          if (
            xmotFormData?.timeline?.nextTimeProductUsed ===
            "next_time_product_used_with_condition"
          ) {
            if (
              !xmotFormData?.timeline.productUsedWithCondition
                ?.selectedDayConditionValue &&
              xmotFormData?.timeline?.trigger_xmot_onetime_type === 2
            ) {
              formErrors.selectedDayConditionValue =
                "Please choose time of day option";
              valid = false;
            }
            if (
              !xmotFormData?.timeline.productUsedWithCondition
                ?.selectedWeekConditionValue &&
              xmotFormData?.timeline?.trigger_xmot_onetime_type === 3
            ) {
              formErrors.selectedWeekConditionValue =
                "Please choose day of week option";
              valid = false;
            }

            if (
              (!xmotFormData?.timeline.productUsedWithCondition
                ?.selectedDayConditionValue ||
                !xmotFormData?.timeline.productUsedWithCondition
                  .selectedWeekConditionValue) &&
              xmotFormData?.timeline?.trigger_xmot_onetime_type === 4
            ) {
              formErrors.selectedDayWeekConditionErr =
                "Please choose day of week option";
              valid = false;
            }
          }
        }
      }

      // ongoing selection validations
      if (xmotFormData?.timeline?.timelineSelection === 2) {
        if (!xmotFormData?.timeline?.triggerTimelineType) {
          formErrors.triggerTimelineTypeErr =
            "Please choose ongoing Product Used Option";
          valid = false;
        }
        if (
          !xmotFormData?.timeline?.noOfUsageEvent &&
          xmotFormData?.timeline?.triggerTimelineType === 5
        ) {
          formErrors.noOfUsageEventErr = "Please choose no. of usage event";
          valid = false;
        }
        if (
          xmotFormData?.timeline?.noOfUsageEvent &&
          xmotFormData?.timeline?.triggerTimelineType === 5
        ) {
          if (parseInt(xmotFormData?.timeline?.noOfUsageEvent) > 10) {
            formErrors.noOfUsageEventErr =
              "This value is configurable up to 10.";
            valid = false;
          } else {
          }
        }
        if (!xmotFormData?.timeline?.windowLength) {
          formErrors.windowLength = "Please add window length";
          valid = false;
        }
        if (!xmotFormData?.timeline?.expireDuration) {
          formErrors.expireDuration = "Please add Expire Duration";
          valid = false;
        }

        if (!xmotFormData?.timeline?.stopXmotBasedOn) {
          formErrors.stopXmotBasedOn = "Please choose stop Xmot";
          valid = false;
        }
        if (!xmotFormData?.timeline?.stopXmotValue) {
          formErrors.stopXmotValue = "Please add stop Xmot value";
          valid = false;
        }
        if (
          xmotFormData?.timeline?.stopXmotBasedOn === 1 &&
          xmotFormData?.timeline?.stopXmotValue < 10
        ) {
          formErrors.stopXmotValue = "Credit value can't be less than 10";
          valid = false;
        }
        if (
          xmotFormData?.timeline?.stopXmotBasedOn === 1 &&
          xmotFormData?.timeline?.stopXmotValue >
            xmotFormData?.seletedCustomRecruit?.xmot_credits
        ) {
          formErrors.stopXmotValue = `Credit value can't be greater than ${xmotFormData?.seletedCustomRecruit?.xmot_credits}`;
          valid = false;
        }
      }
    }

    // Reminder Validations
    if (xmotFormData?.reminder?.reminderSwitch) {
      if (!xmotFormData?.reminder?.reminderTime) {
        formErrors.reminderTime = "Please add Reminder time";
        valid = false;
      }
      if (!xmotFormData?.reminder?.reminderText) {
        formErrors.reminderText = "Please add Reminder text";
        valid = false;
      }
    }

    setTimelineAndReminderErrors(formErrors);
    return valid;
  };

  const validateInstructionAndTQ = () => {
    let formErrors = {};
    let valid = true;

    if (!xmotFormData?.instructions) {
      formErrors.instructionsErr = "Please add instructions";
      valid = false;
    }
    if (xmotFormData?.taskQuestion?.length === 0) {
      formErrors.taskQuestionErr = "Please add Task and Question";
      valid = false;
    }
    if (
      xmotFormData?.taskQuestion?.length > 0 &&
      !xmotFormData?.expectedSessionDuration
    ) {
      formErrors.expectedDurationErr = "Please select Expected Duration";
      valid = false;
    }

    setInstructionAndTQErrors(formErrors);
    return valid;
  };

  const validateTaskQuestion = () => {
    const { surveyType } = xmotFormData;
    // check randomization block

    if (getRandomizeBlocks?.length > 0 && getRandomizeBlocks?.length < 2) {
      showToast({
        severity: "error",
        summary: "Error",
        detail: "Please add at least 2 randomization blocks.",
        life: 4000,
      });
      return true;
    }

    const getEmptyRandomizationBlock = getRandomizeBlocks?.filter(
      (getRandomizeBlock) => getRandomizeBlock?.type === "randomization_block",
    );
    if (getEmptyRandomizationBlock?.length > 0) {
      showToast({
        severity: "error",
        summary: "Error",
        detail: `Please add at least 1 task/question inside the randomization block ${getEmptyRandomizationBlock[0]?.block_name}.`,
        life: 4000,
      });
      return true;
    }

    let hasError = false;
    const updatedTaskQuestion = taskQuestionItems.map((item) => {
      // Handle task type
      if (item.type === "task") {
        if (!item.taskName.trim()) {
          item.isError = true;
          item.errorMsg = "Task name is required.";
          hasError = true;
        } else {
          item.isError = false;
          item.errorMsg = "";
        }

        if (
          item.selectedTaskOption === "view_stimuli" &&
          item.selectedStimuliType === "photo" &&
          !item.instructions.trim()
        ) {
          item.stimuliInstructionErrormsg = "Instructions is required.";
          hasError = true;
        } else {
          item.stimuliInstructionErrormsg = "";
        }

        if (
          item.selectedTaskOption === "view_stimuli" &&
          item.selectedStimuliType === "photo" &&
          !item.photoUrl
        ) {
          item.imgUploadErr = true;
          item.imgUploadErr = "Please upload a photo file.";
          hasError = true;
        } else {
          item.imgUploadErr = false;
          item.imgUploadErr = "";
        }

        if (
          item.selectedTaskOption === "view_stimuli" &&
          item.selectedStimuliType === "video" &&
          !item.videoUrl
        ) {
          item.videoUploadErr = true;
          item.videoUploadErr = "Please upload a video file.";
          hasError = true;
        } else {
          item.videoUploadErr = false;
          item.videoUploadErr = "";
        }

        // if (
        //   item.selectedTaskOption !== "general" &&
        //   item.selectedStimuliType === "video" &&
        //   !item.videoThumbnailUrl
        // ) {
        //   item.videoThumbUploadErr = true;
        //   item.videoThumbUploadErr = "Please upload a video thumbnail file.";
        //   hasError = true;
        // } else {
        //   item.videoThumbUploadErr = false;
        //   item.videoThumbUploadErr = "";
        // }

        // commented due to Remove upload video/photo option from task type
        // if (
        //   item.selectedTaskOption === "upload_photo_video" &&
        //   !item.uploadPhotoVideoInstructions.trim()
        // ) {
        //   item.uploadPhotoVideoInstructionsErr = "Instructions is required.";
        //   hasError = true;
        // } else {
        //   item.uploadPhotoVideoInstructionsErr = "";
        // }

        if (
          item.selectedTaskOption === "capture_photo_video" &&
          !item.captureInstructions.trim()
        ) {
          item.captureInstructionsErr = "Instructions is required.";
          hasError = true;
        } else {
          item.captureInstructionsErr = "";
        }

        if (
          item.selectedTaskOption === "screen_capture" &&
          !item.screenCaptureInstructions.trim()
        ) {
          item.screenCaptureInstructionsErr = "Instructions is required.";
          hasError = true;
        } else {
          item.screenCaptureInstructionsErr = "";
        }

        if (
          item.selectedTaskOption === "barcode" &&
          !item.barcodeInstructions.trim()
        ) {
          item.barcodeInstructionsErr = "Instructions is required.";
          hasError = true;
        } else {
          item.barcodeInstructionsErr = "";
        }
        // Check subTaskQues
        item.subTaskQues = item.subTaskQues.map((sub) => {
          const subItem = { ...sub };

          // Validate questionName
          if (!subItem.questionName.trim()) {
            subItem.isError = true;
            subItem.errorMsg = "Question name is required.";
            hasError = true;
          } else {
            subItem.isError = false;
            subItem.errorMsg = "";
          }

          //validate answerType
          if (
            surveyType === "text" &&
            subItem["open_ended_question"] &&
            !subItem["open_ended_question"]?.answerType?.selectedType?.trim()
          ) {
            subItem["open_ended_question"].answerTypeError =
              "Please select answer type.";
            hasError = true;
          } else {
            subItem["open_ended_question"].answerTypeError = "";
          }

          // Validate for instructions
          [
            "open_ended_question",
            "multiple_choice_single_select",
            "multiple_choice_multi_select",
            "rating_question",
            "ranking_question",
          ].forEach((type) => {
            if (!subItem[type].instructions.trim()) {
              subItem[type].isInstructionError = true;
              subItem[type].instructionErrormsg = "Instructions is required.";
              hasError = true;
            } else {
              subItem[type].isInstructionError = false;
              subItem[type].instructionErrormsg = "";
            }
          });

          // Validate options for different types
          [
            "multiple_choice_single_select",
            "multiple_choice_multi_select",
            "ranking_question",
          ].forEach((type) => {
            subItem[type].options = subItem[type].options.map((opt) => {
              if (!opt.value.trim() && !opt.isOptional) {
                opt.isError = true;
                opt.errorMsg = "Option is required.";
                hasError = true;
              } else {
                opt.isError = false;
                opt.errorMsg = "";
              }
              return opt;
            });
          });

          return subItem;
        });
      }

      // Handle question type
      if (item.type === "question") {
        if (!item.questionName.trim()) {
          item.isError = true;
          item.errorMsg = "Question name is required.";
          hasError = true;
        } else {
          item.isError = false;
          item.errorMsg = "";
        }

        //validate answerType
        if (
          surveyType === "text" &&
          item["open_ended_question"] &&
          !item["open_ended_question"]?.answerType?.selectedType?.trim()
        ) {
          item["open_ended_question"].answerTypeError =
            "Please select answer type.";
          hasError = true;
        } else {
          item["open_ended_question"].answerTypeError = "";
        }

        // Validate for instructions
        [
          "open_ended_question",
          "multiple_choice_single_select",
          "multiple_choice_multi_select",
          "rating_question",
          "ranking_question",
        ].forEach((type) => {
          if (!item[type].instructions.trim()) {
            item[type].isInstructionError = true;
            item[type].instructionErrormsg = "Instructions is required.";
            hasError = true;
          } else {
            item[type].isInstructionError = false;
            item[type].instructionErrormsg = "";
          }
        });

        [
          "multiple_choice_single_select",
          "multiple_choice_multi_select",
          "ranking_question",
        ].forEach((type) => {
          item[type].options = item[type].options.map((opt) => {
            if (!opt.value.trim() && !opt.isOptional) {
              opt.isError = true;
              opt.errorMsg = "Option is required.";
              hasError = true;
            } else {
              opt.isError = false;
              opt.errorMsg = "";
            }
            return opt;
          });
        });
      }

      return item;
    });

    setTaskQuestionItems(updatedTaskQuestion);

    if (hasError) {
      setTimeout(() => {
        const firstError = document.querySelector(".error-input");
        if (firstError) {
          firstError.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          firstError.focus?.();
        }
      }, 150);
    }

    return hasError;
  };

  return (
    <div
      className="container-fluid page-wrapper"
      style={{ position: "relative" }}
    >
      <div className="row">
        <div className="col-12">
          <div className="card shadow-card" style={{ minHeight: "590px" }}>
            <div className="d-flex justify-content-between align-items-center p-3">
              <h6 className="m-0 title fs-13">Create a Custom XMOT</h6>
            </div>
            <Divider />

            <TabView
              className="mt-2 px-3"
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              {tabsData.map((tab, index) => (
                <TabPanel
                  key={index}
                  header={tab.header}
                  leftIcon={tab.icon}
                  disabled={tab.disabled || loading}
                  headerClassName={!tab.disabled ? "enabled-tab" : ""}
                >
                  {tab.content}

                  <div className="py-3 mt-2">
                    <div className="card shadow-card-2 p-1">
                      <div className="d-flex gap-3 mt-4 mb-2">
                        {index !== tabsData.length - 1 ? (
                          <Button
                            label="Save & Continue"
                            className="px-4 py-2 fw-bold createClientBtn d-flex align-items-center"
                            disabled={loading}
                            onClick={() => handleSaveContinue(index)}
                          />
                        ) : (
                          <>
                            <Button
                              label="Cancel"
                              className="px-4 py-2 fw-bold cancel"
                              onClick={() => setActiveIndex(0)}
                            />
                            <Button
                              label="Save as Draft"
                              className="px-4 py-2 fw-bold createClientBtn d-flex align-items-center"
                              disabled={loading}
                              onClick={() => handleSaveLastStep("draft", index)}
                            />
                            <Button
                              label="Save and Publish"
                              className="px-4 py-2 fw-bold createClientBtn d-flex align-items-center"
                              disabled={loading}
                              onClick={() =>
                                handleSaveLastStep("publish", index)
                              }
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </TabPanel>
              ))}
            </TabView>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateSurveyN;
